import { render } from "./OTPLoginForm.vue?vue&type=template&id=7dcec37f&ts=true"
import script from "./OTPLoginForm.vue?vue&type=script&lang=ts"
export * from "./OTPLoginForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Authentication/Login/OTPLoginForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dcec37f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dcec37f', __exports__)) {
    api.reload('7dcec37f', __exports__)
  }
  
  module.hot.accept("./OTPLoginForm.vue?vue&type=template&id=7dcec37f&ts=true", () => {
    api.rerender('7dcec37f', render)
  })

}


export default __exports__